import { getBaseUrl, getTheme } from 'Utils/config';

export const cognito = {
  APP_CLIENT_ID: process.env.APP_CLIENT_ID,
  DOMAIN_AUTH: process.env.DOMAIN_AUTH,
  IDENTITY_POOL_ID: process.env.IDENTITY_POOL_ID,
  REGION: process.env.REGION,
  USER_POOL_ID: process.env.USER_POOL_ID,
};

export const {
  AMPLITUDE_API_KEY,
  BASE_API_V1,
  BPM,
  CUSTOMER_IO_SITE_ID,
  INTERCOM_APP_ID,
  LANDBOT_ID,
  LOCIZE_API_KEY,
  LOCIZE_PROJECT_ID,
  LOCIZE_VERSION,
  PAYMENTS,
  SAT_DATA_GATHERING,
  SEGMENT_KEY,
  SERVICE_USER,
  TYPEFORM_DATAGHATERING_KEY,
  TYPEFORM_SIMULATION_KEY,
  TYPEFORM_DELETE_USER_URL,
  TYPEFORM_ESTIMATED_RESULT_URL,
  TYPEFORM_ESTIMATED_RESULT_PREVIOUS_YEARS_URL,
  TYPEFORM_PAY_LATER_USER_URL,
  WHATSAPP_CONTACT_LINK,
  PAY_LATER_ID,
} = process.env;

export const PAYPAL_CLIENT_ID = process.env.PAYPAL_CLIENT_ID || '';
export const URL_PRIVACY_POLICY = 'https://www.taxdown.com.mx/aviso-privacidad-semana-sagrada/';
export const URL_TERMS_OF_SERVICE = 'https://www.taxdown.com.mx/terms/';
export const { STAGE, NODE_ENV } = process.env;

export const isDevelopment = (): boolean => {
  return STAGE === 'dev' && NODE_ENV === 'production';
};

export const isLocal = (): boolean => {
  return STAGE === 'local';
};

export const isStaging = (): boolean => {
  return STAGE === 'staging' && NODE_ENV === 'production';
};

export const isProduction = (): boolean => {
  return STAGE === 'prod' && NODE_ENV === 'production';
};

export const TAX_YEAR = '2024';

export const THEME_NAME = getTheme();

export const BASE_URL = getBaseUrl();
